const sanitize = require('sanitize-html');

export default {
  message: 'This field may not contain illegal symbols (& < >)',
  fn: (val) => val && val === sanitize(val)
};
